<template>
  <page-outline>
    <template slot="pageContent">
      <div :class="['content bg-light',{ expanded: !isSidebarOpen }]">
        <div>
          <b-container fluid>
            <!-- title -->
            <div class="content-title">
              <b-row>
                <h1>Transaction Ledger</h1>
              </b-row>
              <b-row>
                <span>Comprehensive view of all VIBANs, transactions, and financial reconciliation</span>
              </b-row>
            </div>
            <!-- data -->
            <b-row class="stats">
              <b-col :style="{'border-left': '4px solid '+stat.border}" @click="stat.status != null ? selectStatus(stat.status): stat.type != null ? selectType(stat.type) : ''" v-for="(stat, index) in stats" v-bind:key="index">
                <div>
                  <span>{{ stat.title }}</span>
                  <span :style="{color: stat.color}">{{ index == 0 || index == 1 ? '€' + Number(stat.number).toFixed(2) : stat.number }}</span>
                </div>
              </b-col>
            </b-row>
          </b-container>

          <!-- alert modal for unreconcile button -->
          <alert-modal v-if="isAlertOpen">
            <span><i class="fa-solid fa-circle-check"></i>Transaction sucessfully unreconciled</span>
          </alert-modal>

          <!-- flters -->
          <div class="filters">
            <b-row class="filters-items">
              <!-- Search -->
              <div class="filter-item">
                <span class="filter-item-title">Search</span>
                <input type="text" class="filter-item-content" placeholder="Search by VIBAN, client number, reference, amount or recon ref..." v-model="paginationObj.Search" @input="event => (paginationObj.Search = event.target.value, submit())"  @keyup.enter="submit()"/>
              </div>
              <!-- Type -->
              <div class="filter-item">
                <span class="filter-item-title text-ellipsis">Type</span>
                <a id="type-picker-link"
                  class="filter-item-content d-flex justify-content-between py-2 px-3"
                  href="#">
                  <span class="fixed-span-size">
                    {{ this.paginationObj.Types == null ? 'All Types' : types.filter(item => {
                      if(item.code == this.paginationObj.Types){
                        return item
                      }
                  })[0].label}}
                  </span>
                  <i class="fa-light fa-chevron-down" size="17px" id="action-type-chevron"></i>
                </a>
                <b-popover target="type-picker-link" triggers="focus" placement="bottom" custom-class="popover">
                  <div>
                    <span v-for="(type, index) in types" :key="index" :class="['popover-option', {'popover-option-selected': type.code == paginationObj.Types}]" @click="selectType(type.code)">
                      {{ type.label }}
                    </span>
                  </div>
                </b-popover>
              </div>
              <!-- Status -->
              <div class="filter-item">
                <span class="filter-item-title text-ellipsis">Status</span>
                <a id="status-picker-link"
                  class="filter-item-content d-flex justify-content-between py-2 px-3"
                  href="#">
                  <span class="fixed-span-size">
                    {{ this.paginationObj.Status == null || this.paginationObj.Status == "all" ? 'All Statuses' : statusList.filter(item => {
                      if(item.code == this.paginationObj.Status){
                        return item
                      }
                  })[0].label}}
                  </span>
                  <i class="fa-light fa-chevron-down" size="17px" id="action-type-chevron"></i>
                </a>
                 <b-popover target="status-picker-link" triggers="focus" placement="bottom" custom-class="popover">
                  <div>
                    <span v-for="(status, index) in statusList" :key="index" :class="['popover-option', {'popover-option-selected': status.code == 'all' ? paginationObj.Status == null : status.code == paginationObj.Status}]" @click="selectStatus(status.code)">
                      {{ status.label }}
                    </span>
                  </div>
                </b-popover>
              </div>
               <!-- Filtre date de début -->
              <b-col class="d-flex flex-row">
                <div class="filter-item" >
                  <span class="filter-item-title text-ellipsis" :title="$t('common.date_start_label')">
                    {{ $t('common.date_start_label') }}
                  </span>
                  <datetime-picker class="z-1" format="DD/MM/YYYY"
                    :class="{'filter-item-input': true, 'filter-item-input-complete': dateBegin, 'error-datepicker': dateBeginError}"
                    customInputParentClass="filter-item-content"
                    :maxLength="19"
                    :placeholderValue="$t('common.datetime_picker_empty_date')"
                    inputIcon="fa-solid fa-calendar"
                    v-model="dateBegin"
                    @input="selectBeginDate">
                  </datetime-picker>
                  <span v-if="dateBeginError" class="text-danger">{{$t('errors.Data_format_invalid')}}</span>
                </div>
              </b-col>
              <!-- Filtre date de fin -->
              <b-col class="d-flex flex-row">
                <div class="filter-item" >
                  <span class="filter-item-title text-ellipsis" :title="$t('common.date_end_label')">
                    {{ $t('common.date_end_label') }}
                  </span>
                  <datetime-picker class="z-1" format="DD/MM/YYYY"
                    :class="{'filter-item-input': true, 'filter-item-input-complete': dateEnd, 'error-datepicker': dateEndError}"
                    customInputParentClass="filter-item-content"
                    customInputClass="w-100"
                    :maxLength="19"
                    :placeholderValue="$t('common.datetime_picker_empty_date')"
                    inputIcon="fa-solid fa-calendar"
                    v-model="dateEnd"
                    @input="selectEndDate">
                  </datetime-picker>
                  <span v-if="dateEndError" class="text-danger">{{$t('errors.Data_format_invalid')}}</span>
                </div>
              </b-col>
              <!-- Pagination -->
              <div class="filter-item">
                <span class="filter-item-title text-ellipsis">Per Page</span>
                <a id="pagination-picker-link"
                  class="filter-item-content d-flex justify-content-between py-2 px-3"
                  href="#">
                  <span class="fixed-span-size">{{ this.paginationObj.maxResults }}</span>
                  <i class="fa-light fa-chevron-down" size="17px" id="page-chevron"></i>
                </a>
                <b-popover target="pagination-picker-link" triggers="focus" placement="bottom" custom-class="popover">
                  <div>
                    <span v-for="(resultsPerPage, index) in [10,20,30,40,50]" :key="index" :class="['popover-option', {'popover-option-selected':  resultsPerPage == paginationObj.maxResults}]" @click="selectPagination(resultsPerPage)">
                      {{ resultsPerPage }}
                    </span>
                  </div>
                </b-popover>
              </div>
            </b-row>
            <hr>
            <b-row style="display:flex; align-items:center; justify-content:space-between; padding-right:1rem;">
              <b-col style="display: flex; align-items: center; gap: 1rem;">
                <span v-if="totalResults > 0">Showing {{ paginationObj.firstIndex }} - {{ paginationObj.Status != null || paginationObj.Search != null || paginationObj.country != null ? (totalResults < paginationObj.maxResults ? totalResults : currentPage == Math.ceil(totalResults/paginationObj.maxResults) ? totalResults : currentPage * paginationObj.maxResults )
                  :
                  (totalResults < paginationObj.maxResults ? totalResults : currentPage == Math.ceil(totalResults/paginationObj.maxResults) ? totalResults : currentPage * paginationObj.maxResults ) }} of {{ totalResults }} </span>

                  <span class="selected" v-if="selectedItems.length > 0">{{ selectedItems.length }} selected</span>

                  <button @click="clearSelection()" class="clear" v-if="selectedItems.length > 0"><i class="fa-classic fa-xmark"></i>Clear</button>
              </b-col>

              <div style="display:flex; align-items:center;  gap: 1rem;">

                <button @click="clearFilters()" style="color: #000;" :class="['btn btn-outline-light', {disabled : paginationObj.sortOrder == null && paginationObj.Search == null && paginationObj.Status == null && paginationObj.Types == null && paginationObj.VIBAN == null && paginationObj.DateBegin == null && paginationObj.DateEnd == null}]">Clear Filters</button>

                <button @click="refresh()" class="btn-outline btn-tertiary">
                  <i :class="['fa-classic', 'fa-arrows-rotate', { 'rotate': isLoading }]"></i>
                  Sync Ledger
                </button>

                <button @click="exportSelected()" v-if="selectedItems.length > 0"  class="btn-outline btn-tertiary"><i class="fa-classic fa-arrow-down-to-line"></i>Export Selected ({{ selectedItems.length }})</button>

                <button @click="exportFiltered()" class="btn-outline button-primary"><i class="fa-classic fa-arrow-down-to-line"></i>Export Filtered</button>

                <button @click="exportAll()" class="btn-outline button-primary"><i class="fa-classic fa-arrow-down-to-line"></i>Export All</button>
              </div>
            </b-row>
          </div>
          <!-- VIBANs list -->
          <div v-if="items != null"  class="card">
            <div class="p-6">
              <h2>Transaction Ledger</h2>
              <span>{{ totalResults }} transaction{{ totalResults > 1 ? 's' : '' }}</span>
            </div>
            <hr>
            <div v-if="items.length > 0" style="overflow-x:auto">
              <b-table responsive
                class="table-header-border"
                style="margin-bottom:0;"
                :items="items"
                :fields="fields"
                primary-key="id">

                <template #head(checkbox)>
                  <label class="custom-checkbox">
                    <input type="checkbox"
                      id="all"
                      name="checkAll"
                      @change="selectAll($event)" />
                    <span class="checkmark"></span>
                  </label>
                </template>

                <template #cell(checkbox)="data">
                  <label class="custom-checkbox">
                    <input type="checkbox"
                      :value="data.item"
                      @change="toggleSelection($event, data.item)" />
                    <span class="checkmark"></span>
                  </label>
                </template>

                <template #cell(type)="data">
                  <span v-if="data.item.Type == 1 && data.item.Direction == 0" class="btn btn-empty" style="display: flex; gap: 0.5rem; align-items: center; justify-content: center; cursor: default; color: #008236; background-color: #f0fdf4; border-color: #b9f8cf;"
                  >
                    <i class="fa-light fa-credit-card"></i>
                    Payment
                  </span>

                  <span v-else-if="data.item.Type == 0 && data.item.Direction == 1" class="btn btn-empty" style="display: flex; gap: 0.5rem; align-items: center; justify-content: center; cursor: default; color: #1d4ed8; background-color: #eff6ff; border-color: #bfdbfe;"
                  >
                    <i class="fa-light fa-money-bill"></i>
                    Order
                  </span>

                  <span v-else-if=" data.item.Type == 11 || data.item.Type == 3" class="btn btn-empty" style="display: flex; gap: 0.5rem; align-items: center; justify-content: center; cursor: default; color: #a16207; background-color: #fefce8; border-color: #fef08a;"
                  >
                    <i class="fa-light fa-money-bill-transfer"></i>
                    {{ data.item.Type == 11 ? 'Refund' : data.item.Type == 3 ? 'Credit Note' : '' }}
                  </span>

                  <span v-else>—</span>
                </template>

                <template #cell(VIBAN)="data">
                  <span v-if="data.item.VIBAN !== ''">{{ data.item.VIBAN }}</span>
                  <span v-else>—</span>
                </template>

                <template #cell(clientnumber)="data">
                  <span v-if="data.item.PaymentGroupIdentifier2 !== ''">{{ data.item.PaymentGroupIdentifier2 }}</span>
                  <span v-else>—</span>
                </template>

                <template #cell(reference)="data">
                  <span v-if="data.item.InvoiceIdentifier !== ''">{{ data.item.InvoiceIdentifier }}</span>
                  <span v-else>—</span>
                </template>

                <template #cell(date)="data">
                  <div v-if="data.item.CreationDate != ''">{{isoToDDMMYYYY(data.item.CreationDate)}}</div>
                  <span style="color: #6a7282; font-size: 0.9rem;" v-if="data.item.CreationDate !== ''">{{new Date(Date.parse(data.item.CreationDate )).toLocaleTimeString("it-IT")}}</span>
                  <span v-else >—</span>
                </template>

                <template #cell(duedate)="data">
                  <div v-if="data.item.ExecutionDate != ''">{{isoToDDMMYYYY(data.item.ExecutionDate)}}</div>
                  <span style="color: #6a7282; font-size: 0.9rem;" v-if="data.item.CreationDate !== ''">{{ diffInDays(data.item.ExecutionDate, data.item.CreationDate) }}</span>
                  <span v-else >—</span>
                </template>

                <template #cell(amount)="data">
                  <span :style="{'color': data.item.InvoiceType == 'Standard' && data.item.Direction == 0 ? '#00a63e': data.item.InvoiceType == 'Standard' && data.item.Direction == 1 ? 'red' : data.item.Amount >= 0 ? '#00a63e' : 'red' }">
                    {{data.item.InvoiceType == 'Standard' && data.item.Direction == 0 ? '+' : data.item.InvoiceType === 'Standard' && data.item.Direction == 1 ? '-': '+'}}€{{Number(data.item.Amount).toFixed(2) }}
                  </span>
                </template>

                <template #cell(status)="data">
                  <button style="cursor: default; gap: 0.5rem; display: flex; align-items: center;" v-if="Number(data.item.Status) == 2" :style="{color:'#a16207','background-color':'#fefce8','border-color':'#fef08a'}" class="btn-tertiary-full"><i class="fa-light fa-clock"></i>Pending</button>

                  <button style="cursor: default; gap: 0.5rem; display: flex; align-items: center;" v-else-if="Number(data.item.Status) == 3" class="btn-tertiary-full" :style="{color:'#008236','background-color':'#f0fdf4','border-color':'#b9f8cf'}"><i class="fa-light fa-circle-check"></i>Clean</button>

                  <button style="cursor: default;  gap: 0.5rem; display: flex; align-items: center;" v-else-if="Number(data.item.Status) == 1" class="btn-tertiary-full" :style="{color:'#c10007','background-color':'#fef2f2','border-color':'#c1000773'}"><i class="fa-light fa-triangle-exclamation"></i>Needs Action</button>

                  <span style="cursor: default;  gap: 0.5rem; display: flex; align-items: center;" v-else>—</span>
                </template>

                <template #cell(reconRef)="data">
                  <span style="color: #155dfc; font-size: .75rem;" v-if="data.item.Lettrage">REC-{{ data.item.Lettrage.padStart(6, '0') }}</span>
                  <span v-else>—</span>
                </template>

                <template #cell(description)="data">
                  <span style="color: #4a5565; font-size: .875rem;" v-if="data.item.InvoiceType === 'Standard' && data.item.Direction == 0">Payment received</span>
                  <span style="color: #4a5565; font-size: .875rem;" v-else-if="data.item.InvoiceType === 'Standard' && data.item.Direction == 1">Order created - {{ data.item.email ? data.item.email : 'No Email' }}</span>
                  <span v-else >—</span>
                </template>

                <template #cell(actions)="data">
                  <span v-if="Number(data.item.Status) == 2 || !data.item.Lettrage">—</span>
                  <div style="display: flex;" v-else>
                    <detail-transaction-modal :transaction="data.item"></detail-transaction-modal>
                    <button :id="`unreconcile-btn-${data.index}`" @click="unreconcile(data.item)" class="btn btn-open"><i class="fa-regular fa-file-xmark"></i></button>
                    <b-popover
                      :target="`unreconcile-btn-${data.index}`"
                      triggers="hover"
                      placement="top"
                      custom-class="popover-btn"
                    >
                      Unreconcile
                    </b-popover>
                  </div>
                </template>

              </b-table>
              <hr>
            </div>
            <b-row v-if="items.length > 0" class="pagination">
              <button @click="currentPage > 1 && previous()" :class="['btn-outline-light btn', {inactive: currentPage === 1}]">Previous</button>
              <span>Page {{ currentPage }} of {{ totalPages }}</span>
              <button @click="currentPage < totalPages && next()" :class="['btn-outline-light btn', {inactive: currentPage === totalPages}]">Next</button>
            </b-row>
            <div v-else>
              <span style="display: flex; justify-content: center; margin: 1rem 0rem; color: #6a7282;">No transactions found</span>
            </div>
          </div>
          <div v-else class="card empty">
            <b-spinner label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import AlertModal from '@/components/common/alertModal.vue';
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import detailTransactionModalVue from '@/components/common/detailTransactionModal.vue'
import moment from 'moment'

export default {
  name: 'TransactionLedger',
  components: {
    AlertModal,
    'page-outline': PageOutline,
    'datetime-picker': dateTimePicker,
    'detail-transaction-modal': detailTransactionModalVue
  },
  data(){
    return {
      items: null,
      fields: [
        { key: 'checkbox', thClass: 'text-center align-middle border-bottom bg-light border-left-0 border-right-0', tdClass: 'text-center align-middle'},
        { key: 'date', label: 'Date', thClass: 'text-left align-middle border-bottom bg-light border-left-0 border-right-0', tdClass: 'align-middle text-left'},
        { key: 'duedate', label: 'Due Date', thClass: 'text-left align-middle border-bottom text-nowrap bg-light border-left-0 border-right-0', tdClass: 'align-middle text-left'},
        { key: 'type', label: 'Type', thClass: 'text-left align-middle border-bottom bg-light border-left-0 border-right-0', tdClass: 'align-middle text-left'},
        { key: 'VIBAN', label: 'VIBAN', thClass: 'text-left align-middle border-bottom bg-light border-left-0 border-right-0', tdClass: 'align-middle text-left'},
        { key: 'clientnumber', label: 'Customer', thClass: 'text-left align-middle border-bottom bg-light border-left-0 border-right-0', tdClass: 'align-middle text-left text-nowrap'},
        { key: 'reference', label: 'Reference', thClass: 'text-left align-middle border-bottom bg-light border-left-0 border-right-0', tdClass: 'align-middle text-left text-nowrap'},
        { key: 'amount', label: 'Amount', thClass: 'text-right align-middle border-bottom bg-light border-left-0 border-right-0', tdClass: 'align-middle text-right text-nowrap'},
        { key: 'status', label: 'Status', thClass: 'text-left align-middle border-bottom bg-light border-left-0 border-right-0', tdClass: 'align-middle text-left text-nowrap'},
        { key: 'reconRef', label: 'Recon Ref', thClass: 'text-left align-middle border-bottom text-nowrap bg-light border-left-0 border-right-0', tdClass: 'align-middle text-left'},
        { key: 'description', label: 'Description', thClass: 'text-left align-middle border-bottom bg-light border-left-0 border-right-0', tdClass: 'align-middle text-left text-nowrap'},
        { key: 'actions', label: 'Actions', thClass: 'text-left align-middle border-bottom bg-light border-left-0 border-right-0', tdClass: 'align-middle text-left text-nowrap'}
      ],
      types: [
        {
          label: 'All Types',
          code: null
        },
        {
          label: 'Payments',
          code: 'payments'
        },
        {
          label: 'Orders',
          code: 'orders'
        },
        {
          label: 'Refunds',
          code: 'refund'
        },
        {
          label: 'Helpers',
          code: 'helpers'
        }
      ],
      statusList: [
        {
          label: "All Statuses",
          code: "all"
        },
        {
          label: "Reconciled",
          code: 3
        },
        {
          label: "Pending",
          code: 2
        },
        {
          label: "Unmatched",
          code: 1
        }
      ],
      stats : [
        {
          "title":"Total Debits",
          "number": 0,
          "color": "#e7000b",
          "border": "#e7000b"
        },
        {
          "title":"Total Credits",
          "number": 0,
          "color": "#00c951",
          "border": "#00c951"
        },
        {
          "title":"Total Payments",
          "number": 0,
          "color": "#000",
          "type": "payments"
        },
        {
          "title":"Total Orders",
          "number": 0,
          "color": "#000",
          "type": "orders"
        },
        {
          "title":"Total Reconciled",
          "number": 0,
          "color": "#00a63e",
          "status": 3
        },
        {
          "title":"Total Pending",
          "number": 0,
          "color": "#d08700",
          "status": 2
        }
      ],
      paginationObj: {
        firstIndex: 1,
        maxResults : 10,
        sortOrder: null,
        Search : null,
        Status: null,
        Types : null,
        DateBegin : null,
        DateEnd : null,
        GetDetails: 1
      },
      currentPage: 1,
      totalPages: 0,
      selectedItems: [],
      isSidebarOpen: true,
      isModalOpen: false,
      isLoading: false,
      totalResults: 0,
      totalVibanAvailable: null,
      totalVibanAssigned: null,
      dateBegin: '',
      dateBeginError: false,
      dateEnd: '',
      dateEndError: false,
      isAlertOpen: false,
    }
  },
  created () {
    const id = this.$route.params["id"] == 'null' ? null : this.$route.params["id"]
    this.paginationObj.Search = id ?? null
    this.$engine.services.payments.getTransactions(this.paginationObj)
    .then(resp => {
      const data = resp.data
      this.items = data.Transactions
      this.totalResults = data.nbTotalResults

      this.stats[0].number = data.TotalDebit
      this.stats[1].number = data.TotalCredit
      this.stats[2].number = data.NbPayments
      this.stats[3].number = data.NbOrders
      this.stats[4].number = data.NbReconcilied
      this.stats[5].number = data.NbPending

      this.totalPages = Math.ceil(data.nbTotalResults/this.paginationObj.maxResults)
      this.currentPage = (this.paginationObj.firstIndex -1) / this.paginationObj.maxResults + 1
    })
    .catch(err => {
      console.log(err)
    })
  },
  methods: {
    previous(){
      this.paginationObj.firstIndex = this.paginationObj.firstIndex - this.paginationObj.maxResults
      this.currentPage--
      this.$engine.services.payments.getTransactions(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.Transactions
      })
      .catch(err => {
        console.log(err)
      })
    },
    next(){
      this.paginationObj.firstIndex = this.paginationObj.firstIndex + this.paginationObj.maxResults
      this.currentPage++
      this.$engine.services.payments.getTransactions(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.Transactions
      })
      .catch(err => {
        console.log(err)
      })
    },
    submit(){
      this.paginationObj.firstIndex = 1
      this.currentPage = 1

      this.$engine.services.payments.getTransactions(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.Transactions
        this.totalResults = data.nbTotalResults

        this.stats[0].number = data.TotalDebit
        this.stats[1].number = data.TotalCredit
        this.stats[0].number = data.TotalDebit
        this.stats[1].number = data.TotalCredit
        this.stats[2].number = data.NbPayments
        this.stats[3].number = data.NbOrders
        this.stats[4].number = data.NbReconcilied
        this.stats[5].number = data.NbPending

        this.totalPages = Math.ceil(resp.data.nbTotalResults/this.paginationObj.maxResults)
      })
      .catch(err => {
        console.log(err)
      })
    },
    toggleOrder(){
      this.paginationObj.sortOrder = this.paginationObj.sortOrder == 'asc' ? 'desc' : 'asc';

      this.$engine.services.payments.getGroups(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.references
        this.totalResults = data.nbTotalResults
        this.totalPages = Math.ceil(data.nbTotalResults/this.paginationObj.maxResults)
      })
      .catch(err => {
        console.log(err)
      })

    },
    toggleSelection(event, value) {
      const checked = event.target.checked;

      if (checked) {
        if (!this.selectedItems.some(item => item.InvoiceIdentifier == value.InvoiceIdentifier)) {
          this.selectedItems.push(value)
        }
      } else {
        const checkbox = document.querySelectorAll('input[type="checkbox"]')[0]
        if(checkbox.checked){
          checkbox.checked = false
        }
        this.selectedItems = this.selectedItems.filter(item => item.InvoiceIdentifier !== value.InvoiceIdentifier);
      }
    },
    selectAll(event){
      const checked = event.target.checked;
      const checkboxes = document.querySelectorAll('input[type="checkbox"]')
      if (checked) {
        checkboxes.forEach(item => item.checked = true)
        this.selectedItems = [...this.items];
      } else {
        this.selectedItems = []
        checkboxes.forEach(item => item.checked = false)
      }
    },
    clearSelection() {
      this.selectedItems = []
      const checkboxes = document.querySelectorAll('input[type="checkbox"]')
      checkboxes.forEach(item => item.checked = false)
    },
    selectStatus(status){
      this.paginationObj.firstIndex = 1
      this.currentPage = 1
      this.paginationObj.Status = status == "all" ? null : status

      this.$engine.services.payments.getTransactions(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.Transactions
        this.totalResults = data.nbTotalResults
        this.totalPages = Math.ceil(data.nbTotalResults/this.paginationObj.maxResults)
        document.activeElement?.blur()
      })
      .catch(err => {
        console.log(err)
      })
    },
    selectType(type){
      this.paginationObj.firstIndex = 1
      this.currentPage = 1
      this.paginationObj.Types = type

      this.$engine.services.payments.getTransactions(this.paginationObj)
      .then(resp => {
        const data = resp.data
        this.items = data.Transactions
        this.totalResults = data.nbTotalResults
        this.totalPages = Math.ceil(data.nbTotalResults/this.paginationObj.maxResults)
        document.activeElement?.blur()
      })
      .catch(err => {
        console.log(err)
      })
    },
    formatDate (dateStr) {
      const [day, month, year] = dateStr.split("/");
      return `${year}-${month}-${day}`;
    },
    selectBeginDate (date){
      if(!date){
        this.paginationObj.DateBegin = null
        this.submit()
        return
      }
      this.paginationObj.firstIndex = 1
      this.paginationObj.DateBegin = this.formatDate(date)

      this.$engine.services.payments.getTransactions(this.paginationObj)
      .then(resp => {
        this.items = resp.data.Transactions
        this.totalPages = Math.ceil(resp.data.nbTotalResults/this.paginationObj.maxResults)
      })
      .catch(err => {
        console.log(err)
      })
    },
    selectEndDate (date){
      if(!date){
        this.paginationObj.DateEnd = null
        this.submit()
        return
      }
      this.paginationObj.firstIndex = 1
      this.paginationObj.DateEnd = this.formatDate(date)

      this.$engine.services.payments.getTransactions(this.paginationObj)
      .then(resp => {
        this.items = resp.data.Transactions
        this.totalPages = Math.ceil(resp.data.nbTotalResults/this.paginationObj.maxResults)
      })
      .catch(err => {
        console.log(err)
      })
    },
    selectPagination(resultsPerPage){
      this.paginationObj.maxResults = resultsPerPage
      this.paginationObj.firstIndex = 1

      this.$engine.services.payments.getTransactions(this.paginationObj)
      .then(resp => {
        this.items = resp.data.Transactions
        this.totalPages = Math.ceil(resp.data.nbTotalResults/this.paginationObj.maxResults)
      })
      .catch(err => {
        console.log(err)
      })
    },
    clearFilters (){
      this.dateBegin = null
      this.dateEnd = null
      this.paginationObj = {
        firstIndex: 1,
        maxResults : 10,
        sortOrder: null,
        Search : null,
        Status: null,
        Types : null,
        DateBegin : null,
        DateEnd : null,
        GetDetails: 1
      }

      this.submit()
    },
    exportCSV(filters){
      this.$engine.services.payments.getTransactions(filters)
      .then(resp => {
        const recData = resp
        let firstLine = 'Date/Time;DueDate;Type;VIBAN;Customer;Reference;Amount;Currency;Status;Reconciliation Ref;Description' + '\r\n'

        let line = ''
        
        recData.data.Transactions.forEach(item => {

          const type = item.InvoiceType == 'Standard' && item.Direction == 0 ? 'Payment' : item.InvoiceType == 'Standard' && item.Direction == 1 ? 'Order' : item.InvoiceType != 'Standard' && item.InvoiceType != 'Surplus' ? item.InvoiceType : '';

          const status = Number(item.Status) == 2 ? 'Pending' : Number(item.Status) == 3 ? 'Clean' : Number(item.Status) == 1 ? 'Needs Action' : '';

          line += this.isoToDDMMYYYY(item.CreationDate) + ' ' + new Date(Date.parse(item.CreationDate )).toLocaleTimeString("it-IT") + ';' +  this.diffInDays(item.ExecutionDate, item.CreationDate) + ';' + type + ';' + item.VIBAN + ';' + item.PaymentGroupIdentifier2 + ';' + item.InvoiceIdentifier + ';' + Number(item.Amount).toFixed(2) + ';' + 'EUR' + ';' + status + ';' + item.Lettrage.padStart(6, '0') + ';' + (item.description ?? '') + '\r\n';
        })

        let data = firstLine + line
        let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
        let downloadLink = document.createElement('a')
        let today = moment()
        let fileName = 'transactions_' + today.unix() + '.csv'

        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      })
      .catch(err => {
        console.log(err)
      })
    },
    exportAll () {
      this.exportCSV({})
    },
    exportFiltered () {
      this.exportCSV({
        firstIndex: 1,
        sortOrder: this.paginationObj.sortOrder,
        Search : this.paginationObj.Search,
        Status: this.paginationObj.Status,
        Types : this.paginationObj.Types,
        DateBegin : this.paginationObj.DateBegin,
        DateEnd : this.paginationObj.DateEnd
      })
    },
    exportSelected(){
      const selection = [...this.selectedItems];
      let firstLine = 'Date/Time;DueDate;Type;VIBAN;Customer;Reference;Amount;Currency;Status;Reconciliation Ref;Description' + '\r\n'

      let line = ''

      selection.forEach(item => {
        const type = item.InvoiceType == 'Standard' && item.Direction == 0 ? 'Payment' : item.InvoiceType == 'Standard' && item.Direction == 1 ? 'Order' : item.InvoiceType != 'Standard' && item.InvoiceType != 'Surplus' ? item.InvoiceType : '';

        const status = Number(item.Status) == 2 ? 'Pending' : Number(item.Status) == 3 ? 'Clean' : Number(item.Status) == 1 ? 'Needs Action' : '';

        line += this.isoToDDMMYYYY(item.CreationDate) + ' ' + new Date(Date.parse(item.CreationDate )).toLocaleTimeString("it-IT") + ';' +  this.diffInDays(item.ExecutionDate, item.CreationDate) + ';' + type + ';' + item.VIBAN + ';' + item.PaymentGroupIdentifier2 + ';' + item.InvoiceIdentifier + ';' + Number(item.Amount).toFixed(2) + ';' + 'EUR' + ';' + status + ';' + item.Lettrage.padStart(6, '0') + ';' + (item.description ?? '') + '\r\n';
      })

      let data = firstLine + line
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      let today = moment()
      let fileName = 'transactions_' + today.unix() + '.csv'

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    openModal() {
      this.isModalOpen = true
    },
    confirmAllocation () {
      this.$engine.services.payments.createGroup(this.clientNumber)
      .then(resp => {
        let resObj = {
          status: 200,
          VIBAN: resp.data.VIBAN,
          Reference1: resp.data.Reference1
        }
        this.allocateResult.push(resObj)
      })
      .catch(err => {
        let searchObj = {
          search: this.clientNumber
        }
        this.$engine.services.payments.getGroups(searchObj)
        .then(resp => {
          let resObj = {
            status: 400,
            VIBAN: resp.data.VIBAN,
            Reference1: resp.data.Reference1
          }
          this.allocateResult.push(resObj)
        })
        .catch(err => {
          this.$engine.services.payments.getGroups(searchObj)
        })
      })
    },
    closeModal(){
      this.isModalOpen = false
      this.allocateResult = []
    },
    closeModalGenerate(){
      this.isModalGenerateOpen = false
      this.generateObj = []
    },
    refresh(){
      if (this.isLoading) return;
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        this.paginationObj.firstIndex = 1
        this.paginationObj.maxResults = 10
        this.paginationObj.sortOrder = null
        this.paginationObj.Search = null
        this.paginationObj.Status = null
        this.paginationObj.DateBegin = null
        this.paginationObj.DateEnd = null
        this.paginationObj.country = null
        this.submit()
      }, 800);
    },
    deallocateViban(reference){
      this.$engine.services.payments.deleteGroup(reference)
      .then(resp => {
        if(resp.status == 200){
          this.refresh();
        }
      })
    },
    updateStatus(viban, status){
      this.$engine.services.payments.updateGroup({'VIBAN': viban, 'freeze': status})
      .then(resp => {
        if(resp.status == 200){
          this.refresh();
        }
      })
    },
    isoToDDMMYYYY (isoDate) {
      const [year, month, day] = isoDate.split("T")[0].split("-");
      return `${day}/${month}/${year}`;
    },
    diffInDays (executionDate, creationDate){
      const ms = (1000 * 60 * 60 * 24)
      const diff = (new Date(executionDate) - new Date(creationDate)) / ms
      const days = Math.floor(Math.abs(diff)) + 1
      if(days > 0) {
        return `(Net ${days})`
      } else if (days == 0) {
        return '(Instant)'
      } else {
        return ''
      }
    },
    unreconcile (item){
      const IdTransaction = item.IdTransaction;
      const IdInvoice = parseInt(item.Invoices[0].IdInvoice)
      this.$engine.services.payments.putRapprochement({IdTransaction, IdInvoice})
      .then(resp => {
        if(resp.data.Status == 'OK'){
          this.isAlertOpen = true
          setTimeout(()=>{
            this.isAlertOpen = false;
          }, 3000)
          this.refresh()
        }
      })
    }
  }
}
</script>
<style scoped>

.disabled{
  opacity: 0.5;
  pointer-events: none;
  white-space: nowrap;
}

.rotate {
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.selected {
  padding: 0.5rem;
  font-weight: bold;
  border-radius: calc(0.625rem - 2px);
  background-color: #dbeafe;
  color: #1d4ed8;
}

.clear{
  cursor: pointer;
  padding: 0.5rem;
  font-weight: bold;
  border-radius: calc(0.625rem - 2px);
  border: none;
  display: flex;
  align-items: center;
  gap: 1rem;
  background-color: transparent;
}

.clear:hover{
  background-color: #e9ebef;
}

.fa-circle-question, .fa-chevron-down, .fa-chevron-up{
  margin: 0rem 0.5rem;
  color: #99a1af;
}

.fa-circle-question:hover{
  color: #4a5565;
}

.pagination{
  display: flex;
  align-items: center;
  color: #000000a6;
  padding: 1rem 2rem;
}

table{
  width: 100%;
}

tr{
  padding: 1rem;
  height: 5rem;
}

tr:not(:first-child){
  border-top: 1px solid #0000001a;
}

td, th {
  font-weight: initial;
  padding: 1rem 1rem 1rem 2rem;
  white-space: nowrap;
}

th:nth-of-type(7) {
  text-align: end;
}

td:nth-of-type(5){
  /* font-weight: bold; */
}

td:nth-of-type(7){
  /* font-weight: bold; */
  font-size: 1.25rem;
  text-align: end;
  color: #6a7282;
}

th:nth-of-type(8){
  text-align: center;
}

td:last-of-type{
  display: flex;
  gap: 0.2em;
  justify-content: end;
}

td:first-child, th:first-child{
  width: 6rem;
  padding: 1rem;
}

tr:hover{
  background-color: #f8f9fa;
}

.inactive{
  color: #0a0a0a;
  opacity: .5;;
  pointer-events: none;
  outline-style: none;
}

.content-title{
  margin: 1.5rem 0rem;
}


.content-title>div>span{
  color: #000000a6;
  font-size: 1.1rem;
}

.filters{
  margin: 2rem 0rem;
}

.filters-container{
  width: 100%;
  margin: 2rem 0rem 0rem 0rem;
  border: 1px solid #0000001a;
  border-radius: calc(1rem - 2px);
  background-color: #fff;
  padding: 2rem;
}

.filters-items{
  display: grid;
  grid-template-columns: 3fr 2fr 2fr 2fr 2fr 1fr;
  column-gap: 1rem;
  padding: 0rem 1rem;
}

.stats{
  display: flex;
  gap: 1rem;
  padding: 1rem 0rem;
}

.stats>div{
  display: flex;
  align-items: center;
  height: 8rem;
  background-color: #fff;
  border: 1px solid #0000001a;
  border-radius: calc(1rem - 2px);
  padding: 0rem 1rem;
}

.stats>div:hover:not(:nth-child(1), :nth-child(2)){
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  cursor: pointer;
}

.stats>div>div{
  display: grid;
  row-gap: 1.5rem;
  color: #000000a6;
}

.stats>div>div>span{
font-size: 1rem;
}

.stats>div>div>span:last-of-type{
  font-size: 2rem;
  display: flex;
}
</style>